import { useEffect, useState, useRef, useCallback } from 'react';
import NetInfo from '@react-native-community/netinfo';
import * as Network from 'expo-network';
import audioService from '../../../services/AudioService';
import { preloadCameraIfEnabled } from '../../../helpers/preloadCamera';
import { useSelector, useDispatch } from 'react-redux';
import { fetchLabelData } from '../../../actions/orderActions';
import { SubmitLog } from '../../../actions/saveLogAction';

const CONNECTION_CHECK_INTERVAL = 2000;

const useScanPackServices = (currentOrder, bothSettings) => {
  const dispatch = useDispatch();
  const apiOrder = useSelector(state => state.scanpack?.searchOrder?.data?.order?.[0]);
  const cameraRef = useRef(null);
  const [isConnected, setIsConnected] = useState(true);
  const wasConnected = useRef(true);
  const [isCameraReady, setIsCameraReady] = useState(false);

  const updateConnection = useCallback(connected => {
    setIsConnected(connected);
    if (connected && !wasConnected.current) {
      dispatch(SubmitLog('submitLog'));
    }
    wasConnected.current = connected;
  }, [dispatch]);

  const checkConnection = useCallback(async () => {
    try {
      const networkState = await Network.getNetworkStateAsync();
      updateConnection(networkState.isConnected);
    } catch {
      updateConnection(false);
    }
  }, [updateConnection]);

  useEffect(() => {
    const initServices = async () => {
      await audioService.initializeWithUserSounds();
    };
    initServices();

    const unsubscribe = NetInfo.addEventListener((state) => {
      updateConnection(state.isConnected);
    });

    const intervalId = setInterval(checkConnection, CONNECTION_CHECK_INTERVAL);

    return () => {
      unsubscribe();
      clearInterval(intervalId);
    };
  }, [checkConnection, updateConnection]);

  useEffect(() => {
    if (apiOrder?.print_ss_label && apiOrder?.id) {
      dispatch(fetchLabelData({id: apiOrder.id, app: true}));
    }
  }, [apiOrder?.id]);

  useEffect(() => {
    const loadCamera = async () => {
      const scanPackSetting = bothSettings?.data?.data?.scanpack_setting;
      const storeDisablePackingCam = currentOrder?.storeinfo?.disable_packing_cam;
      const adminToolsPackingCam = bothSettings?.data?.data?.packing_cam;
      const psv2Modules = bothSettings?.data?.data?.post_scanning_config?.modules_config;

      await preloadCameraIfEnabled(
        cameraRef,
        () => {
          setIsCameraReady(true);
        },
        scanPackSetting,
        storeDisablePackingCam,
        adminToolsPackingCam,
        psv2Modules
      );
    };

    if (currentOrder && bothSettings && !cameraRef.current) {
      loadCamera();
    }
  }, [currentOrder, bothSettings]);

  return { 
    isConnected, 
    cameraRef, 
    isCameraReady 
  };
};

export default useScanPackServices;

